import { ReactElement } from 'react';
import { ROOT } from 'configs/routeNames';
import Authorize from '../Authorize';

const AuthorizedRoute = (props: AuthorizedRouteInterface): ReactElement => {
  const { requiredPermissions, redirect, Component, checkSubject = false, subject } = props;

  return (
    <Authorize
      redirect={redirect || ROOT}
      requiredPermissions={requiredPermissions}
      checkSubject={checkSubject}
      subject={subject}
    >
      <Component />
    </Authorize>
  );
};

interface AuthorizedRouteInterface {
  requiredPermissions?: { action: string; subject: string }[];
  redirect?: string;
  Component: React.ComponentType;
  checkSubject?: boolean;
  subject?: string;
}
export default AuthorizedRoute;
